import { object, string, boolean } from "yup";

const regionSchema = object({
  name: string()
    .trim()
    .required("Region name is required")
    .matches(
      /^[a-zA-Z0-9\-:;() ]*$/,
      "Only alphanumerics, hyphens, brackets, colons and semi-colon are allowed."
    ),
  active: boolean()
});

export default regionSchema;
